import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Layers = createReactComponent("Layers", ["svg", defaultAttributes, [["polygon", {
  points: "12 2 2 7 12 12 22 7 12 2",
  key: "gzi815"
}], ["polyline", {
  points: "2 17 12 22 22 17",
  key: "j6unwi"
}], ["polyline", {
  points: "2 12 12 17 22 12",
  key: "1akav3"
}]]]);
export default Layers;